import React from 'react'
import styled from 'styled-components'
import { NOT_AVAILABLE } from '../../../../utils/constants'
import { Container, Text, PageLinkButton } from '../../../Global'

const WrapContainer = styled(Container)`
  word-break: break-word;
  white-space: normal;
  overflow: visible;
  text-align: left;

  > button {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    max-width: unset;
    width: 100%;
    height: auto;
    line-height: 1.4;
    text-align: left;
  }
`

export const TableDataCellCampaignName = ({
  dataValue = NOT_AVAILABLE,
  navigate = () => {},
}: {
  dataValue?: string
  navigate: () => void
}) => {
  return (
    <WrapContainer>
      <PageLinkButton onClick={navigate}>
        <Text>{dataValue}</Text>
      </PageLinkButton>
    </WrapContainer>
  )
}
